import React from 'react';
import './AccountTypeSelection.css';

function AccountTypeSelection({ onSelectType, onBack }) {
  return (
    <div className="account-type-container">
      <button className="back-button-circle" onClick={onBack} type="button">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 15L7.5 10L12.5 5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <div className="account-type-header">
        <h1>Sign up for LeadGen</h1>
        <p>Choose how you want to use our platform</p>
      </div>

      <div className="account-type-options">
        <button
          className="account-type-card"
          onClick={() => onSelectType('personal')}
          type="button"
        >
          <div className="account-type-icon personal">
            <i className="fas fa-user-tie"></i>
          </div>
          <h3>I am a Personal User</h3>
          <p>For individual professionals and solo entrepreneurs</p>
        </button>

        <button
          className="account-type-card"
          onClick={() => onSelectType('organization')}
          type="button"
        >
          <div className="account-type-icon organization">
            <i className="fas fa-sitemap"></i>
          </div>
          <h3>I am a Company / Organization</h3>
          <p>For teams, agencies, and growing businesses</p>
        </button>
      </div>

      <div className="account-type-footer">
        <p>
          Already have an account?{' '}
          <button onClick={onBack} className="auth-link-button">
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
}

export default AccountTypeSelection;
